export const TOTAL_ID_PREFIX = 'total_row'

export const sortDirectionConstant = {
  ASC: 'asc',
  DESC: 'desc',
}

export const selectComponentTypes = {
  radioButton: 'radiobutton',
  checkbox: 'checkbox',
}
